import { Logger } from '@west-australian-newspapers/typescript-log'
import { BaseClientConfig } from '../client/BaseClientConfig'
export interface RegistrationSessionDetails {
    email: string
    honeypot: string | undefined
    state: string
    client_id: string | undefined
    redirect_uri: string
}

// Used to kickoff the email registration via the auth site
export async function startRegistration(
    config: BaseClientConfig,
    log: Logger,
    regDetails: RegistrationSessionDetails,
): Promise<boolean> {
    const { client_id, email, honeypot, redirect_uri, state } = regDetails

    try {
        /**
         * The userconfirm endpoint uses x-www-form-urlencoded data, which can be created
         * using URLSearchParams to automatically set the headers. However this isn't
         * supported in IE11, so instead we've manually set the headers and created the
         * body data.
         */
        const headers = new Headers()
        headers.append(
            'Content-Type',
            'application/x-www-form-urlencoded;charset=UTF-8',
        )
        const body = `email=${encodeURIComponent(
            email,
        )}&state=${state}&client_id=${client_id}&redirect_uri=${redirect_uri}`

        const response = await fetch(
            `${config.auth?.issuer}/register?honeypot=${honeypot}`,
            {
                method: 'POST',
                headers,
                body,
            },
        )

        return response.status === 200
    } catch (err) {
        log.error(
            { error: err as Error },
            'Error calling auth /register endpoint',
        )
        return false
    }
}
